
<template>
  <div class="pointer">
    <div class="pointer-dot">
      <div class="click"></div>
    </div>
  </div>
</template>

<script>
// Modules
import { gsap, Power2 } from 'gsap'
import { userAgent } from '../services/user-agent.service'
export default {
  name: 'MousePointer',
  mounted () {
    var isMobile = userAgent()
    this.initPointer(!isMobile)
    this.initClickAnimation(!isMobile)
  },
  methods: {

    initPointer (enable) {
      if (enable) {
        // Bind pointnter elemtnt to mouse position
        document.addEventListener('mousemove', (e) => {
          gsap.to('.pointer-dot', 0, {
            left: e.pageX,
            top: e.pageY - document.querySelector('html').scrollTop
          })
        })

        // Events fade in/out cursor when leaving the browser window
        document.addEventListener('mouseleave', function (e) {
          if (e.pageY <= 0 || e.pageX <= 0 || (e.pageX >= window.innerWidth || e.pageY >= window.innerHeight)) {
            gsap.to('.pointer', 0.35, {
              autoAlpha: 0
            })
          }
        })
        document.addEventListener('mouseenter', function (e) {
          gsap.to('.pointer', 0.35, {
            autoAlpha: 1
          })
        })
      } else {
        gsap.set('.pointer', { display: 'none' })
        gsap.set('#app', { className: '-=pointer-active' })
      }
    },

    initClickAnimation (enable) {
      document.addEventListener('click', function () {
        const clickEl = '.pointer .pointer-dot .click'
        if (clickEl && enable) {
          gsap.fromTo(clickEl, 0.65, {
            width: 0,
            height: 0,
            opacity: 1
          }, {
            width: '40px',
            height: '40px',
            opacity: 0,
            ease: Power2.easeOut
          })
        }
      })
    }
  },
  computed: {
    pointerDragable () {
      return this.$store.state.general.menu.isOpen
    }
  }
}

</script>
<style lang="scss" scoped>
@import '../assets/styles/variables';
.pointer {
  &.hover {
    .pointer-dot{
      width: 25px;
      height: 25px;
      opacity: .6;
      box-shadow: 0 0 0 0 rgba($indigo, 0);
      background: $gold;
    }
  }
  .pointer-dot {
    transition: width .3s ease, height .3s ease, opacity .3s ease, box-shadow .3s ease, background .3s ease;
    position: fixed;
    z-index: 1000;
    width: 10px;
    height: 10px;
    pointer-events: none;
    background: $indigo;
    border-radius: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 1px 2px 5px 0 rgba($indigo, 0.5);
    .click {
      position: absolute;
      top: 50%;
      left: 50%;
      background: rgba($indigo, .5); // sass-lint:disable-line no-color-literals
      border-radius: inherit;
      content: "";
      transform: translate(-50%, -50%);
    }
  }
}
</style>
